import { useNavigate } from "@tanstack/react-router"
import { useCreateTenantMutation } from "./api"
import type { Tenant } from "./model"
import { setTenantSlug, useRedirectAfterLogin } from "@/auth"
import { useDispatch } from "@/base"
import { ApiFormWrapper, FormError, FormInput, FormSubmitButton } from "@/form"

export default function TenantCreateForm() {
  const [createTenant] = useCreateTenantMutation()
  const { getRedirectUrl } = useRedirectAfterLogin()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // Enter the new workspace (the backend made it current) before leaving, so
  // the redirect lands in it
  const handleSuccess = ({ slug }: Tenant) => {
    dispatch(setTenantSlug(slug))

    return navigate({ to: getRedirectUrl(), replace: true })
  }

  return (
    <ApiFormWrapper
      defaultValues={{ name: "" }}
      action={createTenant}
      onSuccess={handleSuccess}
    >
      <FormInput name="name" autoFocus required className="mb-3 w-full" />
      <FormError />
      <FormSubmitButton>Create Workspace</FormSubmitButton>
    </ApiFormWrapper>
  )
}
